import React from "react";

function StarSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M7.99164 18.9231L9.23164 13.6101L5.10864 10.0381L10.5396 9.56813L12.6666 4.55713L14.7936 9.56713L20.2236 10.0371L16.1006 13.6091L17.3416 18.9221L12.6666 16.1021L7.99164 18.9231Z"
        fill="#FFBF00"
      />
    </svg>
  );
}

export default StarSVG;
